"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentSessionData = exports.updateSessionData = void 0;
const SessionDataKeyName = 'revjet.session.data';
function updateSessionData(data) {
    if (typeof window !== 'undefined') {
        const serializedSessionData = window.sessionStorage.getItem(SessionDataKeyName);
        let currentSessionData = serializedSessionData != null ? JSON.parse(serializedSessionData) : {};
        const persistent = data.persistent;
        if (persistent) {
            currentSessionData = {
                ...currentSessionData,
                ...persistent
            };
        }
        const session = data.session;
        if (session) {
            currentSessionData = {
                ...currentSessionData,
                ...session
            };
        }
        window.sessionStorage.setItem(SessionDataKeyName, JSON.stringify(currentSessionData));
    }
}
exports.updateSessionData = updateSessionData;
function getCurrentSessionData() {
    if (typeof window !== 'undefined') {
        const serializedSessionData = window.sessionStorage.getItem(SessionDataKeyName);
        return serializedSessionData != null ? JSON.parse(serializedSessionData) : {};
    }
    else {
        return {};
    }
}
exports.getCurrentSessionData = getCurrentSessionData;
//# sourceMappingURL=session.js.map